export const PRINT_PREVIEW_STORAGE_PREFIX = 'print-preview-job:';

export const createPrintBlobUrl = (html: string): string =>
  URL.createObjectURL(new Blob([html], { type: 'text/html' }));
